import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["data"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import List from "@/components/List";
import ListRow from "@/components/Row/ListRow/index";
import { useRtRecommendQuery } from "@/hooks";
import { jsx as _jsx } from "react/jsx-runtime";
var RECOMMEND_PAGE_LIMIT = 5;
export default function RtRecommendList(_ref) {
  var elementId = _ref.elementId,
      header = _ref.header;

  var _useRtRecommendQuery = useRtRecommendQuery({
    variables: {
      location: "".concat(window.location.origin).concat(window.location.pathname),
      elementIds: [elementId]
    },
    fetchPolicy: "cache-first"
  }),
      data = _useRtRecommendQuery.data,
      result = _objectWithoutProperties(_useRtRecommendQuery, _excluded);

  if (!(data !== null && data !== void 0 && data.recommend)) return null;
  var items = data === null || data === void 0 ? void 0 : data.recommend.find(function (data) {
    return data.elementId === elementId;
  });
  return /*#__PURE__*/_jsx(List, _objectSpread(_objectSpread({}, result), {}, {
    itemComponent: ListRow,
    header: header,
    items: items,
    limit: RECOMMEND_PAGE_LIMIT,
    viewTypeClassName: "list",
    loadMore: false
  }));
}